import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PPMAnalytics from '../analytics/PPMAnalytics';
import PPMContracts from '../PPMContracts';
import PPMContractDetail from '../PPMContractDetail';
import PPMQuotes from '../PPMQuotes';
import PPMQuoteDetail from '../PPMQuoteDetail';

const PpmRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<PPMAnalytics />} />
      <Route path="contracts" element={<PPMContracts />} />
      <Route path="contracts/:id" element={<PPMContractDetail />} />
      <Route path="quotes" element={<PPMQuotes />} />
      <Route path="quotes/:id" element={<PPMQuoteDetail />} />
    </Routes>
  );
};

export default PpmRoutes;
